export { default as MegaMenuCustom, isSingleMegaMenu } from './MegaMenuCustom';
